import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import AppSettings from '../../AppSettings';
// Composants
import Notifications from '../Utils/Notifications';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRightToBracket, faBuilding, faCaretDown, faCaretRight, faCircle, faDownload, faFileAlt, faFolder, faFolders, faGavel, faHouse, faLock, faMoon, faPenToSquare, faShieldPlus, faSignOut, faSun, faSync, faUpload, faUser, faUsers, faWifi, faWifiSlash } from '@fortawesome/pro-solid-svg-icons'
import { faCircle as faCircleRegular } from '@fortawesome/pro-regular-svg-icons'
import Tasks from '../../components/Utils/Tasks';
import { Menu, Label, Popup, Dropdown, Flag } from 'semantic-ui-react'
import ProFeaturesButton from '../Utils/ProFeaturesButton';
// Librairies
import i18n from '../../locales/i18n';
import { connect } from 'react-redux';
import { setIsDarkTheme } from '../../actionCreators/appActions';
import { setUserInfos } from '../../actionCreators/usersActions';
import { setCurrentFolderState, setProjectShortcut } from '../../actionCreators/componentsActions';
import { setHomeInfos } from '../../actionCreators/usersActions';
import { setProjectInvitations } from '../../actionCreators/projectsActions';
// Ressources
import banner from '../../resources/images/banner.png';
import bannerDT from '../../resources/images/banner-dt.png';
import urbasensePNG from '../../resources/pngs/urbasense-banner.png';
// Services
import UsersService from '../../services/UsersService';
// Styles
import '../../styles/rainbow.css';
// Utils
import { showToast } from '../../utils/ToastsUtil';
import LanguagesUtil from '../../utils/LanguagesUtil';
import RightsUtil from '../../utils/RightsUtil';
import OrganizationsService from '../../services/OrganizationsService';

class BrowserNavbar extends Component {
    state = {
        connectionState: 2,
        showPopup: false,
        showOrganizationList: false
    }

    render() {
        const { logged, activeItem, userInfos, activeOrganization, project, isDarkTheme, currentAction, isPreview, theme, logoUrl, organizations } = this.props;
        const { showOrganizationList } = this.state;
        const blobInfos = AppSettings.getBlobInfos();

        const subscription = logged && activeOrganization?.subscription;
        const firstName = userInfos?.firstName;
        const culture = LanguagesUtil.getUserCulture(this.props.userInfos);
        const sync = this.props.sync?.state && !isNaN(this.props.sync.nbDone) && !isNaN(this.props.sync.nbMax) ? this.props.sync : null;
        const connectionState = this.state.connectionState;
        const isUrbasense = AppSettings.isUrbasenseUrl();

        return (
            <Menu style={{ margin: 0, height: '60px', flexShrink: 0, pointerEvents: isPreview && 'none' }} id='navbar'>
                {!isUrbasense && project?.theme?.logoName?.length && project.organization.subscription.branding ?
                    <a className='navbar-logo' target='_blank' rel='noopener noreferrer' href={project.theme.website} style={{ height: '100%', padding: '5px 12px' }}>
                        <img style={{ height: '100%', width: '100%' }} alt={project.theme.label} src={AppSettings.getBlobUrl(blobInfos.containers.photos, project.theme.logoName)} />
                    </a>
                    : <img className='navbar-logo' style={{ height: '100%', width: 'auto', padding: isUrbasense ? '0 5px' : '0 12px 0 4px' }} alt='Grality logo' src={!isUrbasense ? (logoUrl || (isDarkTheme ? bannerDT : banner)) : urbasensePNG} />}
                {this.props.logged &&
                    <Menu.Item
                        as={Link} to='/' name='home' active={activeItem === 'home'} id='SdTQ8Z1Y'
                        onClick={() => {
                            this.props.setCurrentFolderState(null);
                            this.props.showProjectList(false, { renderDefaultMap: false });
                        }}
                    >
                        <FontAwesomeIcon icon={faHouse} style={{ marginRight: '10px' }} />{i18n.t("Accueil")}
                    </Menu.Item>}
                {!logged ?
                    <>
                        {project &&
                            <Menu.Item className='navbar-project'>
                                <FontAwesomeIcon icon={faFileAlt} style={{ marginRight: '10px' }} /><span className='text-ellipsis' title={project.label}>{project.label}</span>
                            </Menu.Item>}
                        {/* <Menu.Item as={Link} to='/subscriptions' active={activeItem === 'subscriptions'}>
                            <FontAwesomeIcon icon={faCircleDollar} style={{ marginRight: '10.5px' }} /> {i18n.t("Abonnements")}
                        </Menu.Item> */}
                    </>
                    :
                    <>
                        <Menu.Item
                            as={activeItem !== 'projectMap' && activeItem !== 'home' ? Link : null}
                            to='/' id='EAbEwOUy'
                            onClick={() => {
                                if (currentAction !== 'modifyingProjectSurroundings') this.props.showProjectList(true);
                                else showToast('finish_resizing');
                            }}
                        >
                            <FontAwesomeIcon icon={faFolders} style={{ marginRight: '10px' }} />{i18n.t("Mes projets")}
                        </Menu.Item>
                        {this.props.currentFolderState &&
                            <Menu.Item
                                className='navbar-project'
                                onClick={() => {
                                    if (currentAction !== 'modifyingProjectSurroundings') this.props.showProjectList(true, { showCurrentFolder: true });
                                    else showToast('finish_resizing');
                                }}
                            >
                                <FontAwesomeIcon icon={faFolder} style={{ marginRight: '10px' }} />
                                <span className='text-ellipsis' title={this.props.currentFolderState.currentFolder?.label}>{this.props.currentFolderState.currentFolder?.label}</span>
                            </Menu.Item>}
                        {(!this.props.editedProperties?.project || this.props.editedProperties.project?.id === project?.id) && <>
                            {project?.type === 'project' ?
                                <Dropdown
                                    item simple disabled={isPreview} className='navbar-project'
                                    trigger={<>
                                        <FontAwesomeIcon icon={faFileAlt} style={{ marginRight: '10px' }} />
                                        <span className='text-ellipsis' title={project.label}>{project.label}</span>
                                    </>}
                                >
                                    <Dropdown.Menu style={{ zIndex: 1000 }}>{this.renderOptions()}</Dropdown.Menu>
                                </Dropdown>
                                : project &&
                                <Dropdown
                                    item simple disabled={isPreview} className='navbar-project'
                                    trigger={<>
                                        <FontAwesomeIcon icon={faFolder} style={{ marginRight: '10px' }} />
                                        <span className='text-ellipsis' title={project?.label || theme?.label || 'Projet'}>{project?.label || theme?.label || 'Projet'}</span>
                                    </>}
                                >
                                    <Dropdown.Menu style={{ zIndex: 1000 }}>{this.renderOptions()}</Dropdown.Menu>
                                </Dropdown>}
                        </>}
                    </>}
                <Menu.Menu position='right'>
                    {!connectionState && !sync ?
                        <Popup
                            open={this.state.showPopup}
                            trigger={
                                <Menu.Item onClick={() => this.setState({ showPopup: !this.state.showPopup })}>
                                    <FontAwesomeIcon icon={!connectionState ? faWifiSlash : faWifi} color={!connectionState ? 'red' : connectionState === 1 ? 'orange' : 'green'} />
                                </Menu.Item>
                            }
                            position='bottom center'
                            content={!connectionState
                                ? i18n.t("Pas d'accès internet")
                                : i18n.t("La connexion est faible, il est recommandé de travailler en mode hors ligne")}
                            style={{ zIndex: 700 }}
                        />
                        : sync &&
                        <Menu.Item>
                            <Popup
                                position='top center' content={`${i18n.t("Synchronisation en cours...")} (${sync.nbDone}/${sync.nbMax})`}
                                trigger={<FontAwesomeIcon icon={faSync} size='2x' color='green' />}
                            />
                        </Menu.Item>}
                    <Dropdown item simple trigger={<><Flag name={LanguagesUtil.getCultureFlagName(culture)} /> {culture.split('-')[0].toUpperCase()}</>}>
                        <Dropdown.Menu style={{ zIndex: 1200 }}>
                            <Dropdown.Item active={culture?.toLowerCase().includes('fr')} onClick={() => this.changeLanguage('fr-BE')}>
                                <Flag name='fr' /> FR
                            </Dropdown.Item>
                            <Dropdown.Item active={culture?.toLowerCase().includes('nl')} onClick={() => this.changeLanguage('nl-BE')}>
                                <Flag name='nl' /> NL
                            </Dropdown.Item>
                            <Dropdown.Item active={culture?.toLowerCase().includes('en')} onClick={() => this.changeLanguage('en-US')}>
                                <Flag name='gb' /> EN
                            </Dropdown.Item>
                            <Dropdown.Item active={culture?.toLowerCase().includes('es')} onClick={() => this.changeLanguage('es-ES')}>
                                <Flag name='es' /> ES
                            </Dropdown.Item>
                            <Dropdown.Item active={culture?.toLowerCase().includes('zh')} onClick={() => this.changeLanguage('zh-CHT')}>
                                <Flag name='tw' /> ZH
                            </Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
                    {!logged &&
                        <>
                            {!isUrbasense &&
                                <Menu.Item onClick={() => {
                                    this.props.setIsDarkTheme(!isDarkTheme).then(() => localStorage.setItem('isDarkTheme', !isDarkTheme));
                                }}>
                                    {isDarkTheme
                                        ? <><FontAwesomeIcon icon={faSun} style={{ marginRight: '10px' }} />{i18n.t("Mode jour")}</>
                                        : <><FontAwesomeIcon icon={faMoon} style={{ marginRight: '10px' }} />{i18n.t("Mode nuit")}</>}
                                </Menu.Item>}
                            <Menu.Item as={Link} to='/signup' active={activeItem === 'signup'}>
                                <FontAwesomeIcon icon={faPenToSquare} style={{ marginRight: '10px' }} />{i18n.t("Inscription")}
                            </Menu.Item>
                            <Menu.Item as={Link} to='/login' active={activeItem === 'login'}>
                                <FontAwesomeIcon icon={faArrowRightToBracket} style={{ marginRight: '10px' }} />{i18n.t("Connexion")}
                            </Menu.Item>
                        </>}
                    {logged &&
                        <>
                            {!isPreview && <>
                                <Tasks />
                                <Notifications />
                            </>}
                            <Dropdown
                                item simple id='Yj5V0rzR'
                                onClose={() => {
                                    if (showOrganizationList)
                                        this.setState({ showOrganizationList: false })
                                }}
                                trigger={<div style={{ display: 'flex', flexDirection: 'column' }}>
                                    <div>
                                        <span style={{ fontWeight: 'bold' }}>{firstName}</span>
                                        {subscription &&
                                            <Label
                                                horizontal className={subscription.shortName !== 'Dev' ? null : 'rainbow-bg'}
                                                style={subscription.shortName !== 'Dev'
                                                    ? { background: subscription.color, boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)', marginLeft: '10px', padding: '4px' }
                                                    : { boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)', marginLeft: '10px', color: 'white', padding: '4px' }}
                                            >
                                                {subscription.shortName}
                                            </Label>}
                                    </div>
                                    {activeOrganization &&
                                        <span className='no-themed' style={{ marginTop: '3px', fontSize: '10pt', color: 'var(--grey-60)' }}>{activeOrganization.label}</span>}
                                </div>}>
                                <Dropdown.Menu style={{ zIndex: 1200 }}>
                                    {['Dev', 'Admin', 'Com'].includes(subscription?.shortName) &&
                                        <Dropdown.Item as={Link} to='/adminPanel' target={project ? '_blank' : null} active={activeItem === 'adminPanel'}>
                                            <FontAwesomeIcon icon={faGavel} style={{ marginRight: '10px' }} />{i18n.t("Administration")}
                                        </Dropdown.Item>}
                                    {organizations?.length > 1 && <>
                                        <Dropdown.Item style={{ display: 'flex' }} onClick={() => this.setState(prevState => ({ showOrganizationList: !prevState.showOrganizationList }))}>
                                            <span style={{ marginRight: 'auto', fontWeight: 'bold' }}>{activeOrganization.label} ({organizations.length})</span>
                                            <FontAwesomeIcon icon={showOrganizationList ? faCaretDown : faCaretRight} style={{ marginLeft: '10px', justifySelf: 'flex-end', width: '9px' }} />
                                        </Dropdown.Item>
                                        {showOrganizationList && (
                                            <div style={{
                                                maxHeight: '300px',
                                                overflowY: 'auto',
                                            }}>
                                                {organizations.map(organization => (
                                                    <Dropdown.Item
                                                        key={organization.id}
                                                        className={'organization-item' + (organization.id === activeOrganization.id ? ' selected' : '')}
                                                        disabled={organization.id === activeOrganization.id}
                                                        onClick={() => this.changeOrganization(organization)}
                                                    >
                                                        <span style={{ paddingLeft: '9px', display: 'flex', alignItems: 'center' }}>
                                                            <FontAwesomeIcon
                                                                icon={organization.id === activeOrganization.id ? faCircle : faCircleRegular}
                                                                style={{ fontSize: '7px', marginRight: '8px' }}
                                                            />
                                                            {organization.label}
                                                        </span>
                                                    </Dropdown.Item>
                                                ))}
                                            </div>
                                        )}
                                    </>}
                                    <Dropdown.Item as={Link} to='/organizationPanel/general' target={project ? '_blank' : null} active={activeItem === 'organizationPanel'}>
                                        <FontAwesomeIcon icon={faBuilding} style={{ marginRight: '10px' }} />{i18n.t("Mon organisation")}
                                    </Dropdown.Item>
                                    <Dropdown.Item as={Link} to='/accountPanel/general' target={project ? '_blank' : null} active={activeItem === 'accountPanel'}>
                                        <FontAwesomeIcon icon={faUser} style={{ marginRight: '10px' }} />{i18n.t("Mon compte")}
                                    </Dropdown.Item>
                                    {/* <Dropdown.Item as={Link} to='/subscriptions' active={activeItem === 'subscriptions'}>
                                        <FontAwesomeIcon icon={faCircleDollar} style={{ marginRight: '10.5px' }} /> {i18n.t("Abonnements")}
                                    </Dropdown.Item> */}
                                    {!isUrbasense &&
                                        <Dropdown.Item onClick={(e) => {
                                            e.stopPropagation();
                                            this.props.setIsDarkTheme(!isDarkTheme).then(() => localStorage.setItem('isDarkTheme', !isDarkTheme));
                                        }}>
                                            {isDarkTheme
                                                ? <><FontAwesomeIcon icon={faSun} style={{ marginRight: '10px' }} />{i18n.t("Mode jour")}</>
                                                : <><FontAwesomeIcon icon={faMoon} style={{ marginRight: '10px' }} />{i18n.t("Mode nuit")}</>}
                                        </Dropdown.Item>}
                                    <Dropdown.Item
                                        as={Link} to='/login' style={{ display: logged ? 'flex' : 'none' }}
                                        active={activeItem === 'login'} id='lgMC9pEX' onClick={() => {
                                            this.props.setCurrentFolderState(null);
                                            this.props.logUser(null);
                                        }}
                                    >
                                        <FontAwesomeIcon icon={faSignOut} style={{ marginRight: '10px' }} />{i18n.t("Déconnexion")}
                                    </Dropdown.Item>
                                </Dropdown.Menu>
                            </Dropdown>
                        </>}
                </Menu.Menu>
            </Menu>
        );
    }

    componentDidMount = () => {
        const connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
        if (connection) {
            this.checkConnectionSpeed(connection);
            connection.onchange = () => this.checkConnectionSpeed(connection);
        }
    }

    checkConnectionSpeed = (connection) => {
        const connectionState = this.state.connectionState;
        const downlink = connection.downlink;
        let shouldUpdate = false;

        switch (connectionState) {
            case 0: if (downlink > 0) shouldUpdate = true; break;
            case 1: if (!downlink || downlink >= 1) shouldUpdate = true; break;
            case 2: if (downlink < 1) shouldUpdate = true; break;
            default: break;
        }

        if (shouldUpdate) {
            this.setState({
                connectionState: !downlink ? 0 : downlink < 1 ? 1 : 2,
                showPopup: true
            }, () => setTimeout(() => this.setState({ showPopup: false }), 5000));
        }
    }

    showNotifications = () => {
        this.setState(prevState => ({ notificationsRead: !prevState.notificationsRead }));
    }

    changeLanguage = (culture) => {
        if (this.props.userInfos) {
            UsersService.changeLanguage(culture).then(response => {
                this.props.setUserInfos({ ...this.props.userInfos, language: response.data });
                LanguagesUtil.clearLists();
                i18n.changeLanguage(culture);
                window.location.reload();
            });
        } else {
            LanguagesUtil.clearLists();
            i18n.changeLanguage(culture);
            window.location.reload();
        }
    }

    changeOrganization = (organization) => {
        if (!organization || organization.id === this.props.activeOrganization.id) return;
        OrganizationsService.updateActiveOrganization(organization.id).then((response) => {
            if (response) window.location.reload();
        });
    }

    renderOptions = () => {
        const { activeOrganization, rights, loginAsData, isOnline, project } = this.props;
        const projectSubscription = project.organization.subscription;
        const isEditable = rights && (rights.parameters || rights.publicFields || rights.requiredFields || rights.formulas) && isOnline;
        const areRightsChangeable = rights?.rights && projectSubscription.nbCollaborators && isOnline;
        const isImportable = RightsUtil.canImportGlobally(rights) && projectSubscription.import && activeOrganization?.subscription.import && isOnline && !loginAsData?.readOnly;
        const isExportable = RightsUtil.canExportGlobally(rights) && projectSubscription.export && activeOrganization?.subscription.export && isOnline;
        const isFileGalleryAvailable = projectSubscription.filesSharing;

        return (<>
            <Dropdown.Item
                icon='users' text={i18n.t("Gérer les collaborateurs")} style={{ display: 'flex', gap: '10px' }}
                onClick={(e) => this.changeModalContentType(e, 'CollaboratorList', 'Gestion des collaborateurs', this.props.project, areRightsChangeable)}
            >
                <FontAwesomeIcon icon={faUsers} style={{ aspectRatio: '1 / 1' }} />
                {i18n.t("Gérer les collaborateurs")}
                <ProFeaturesButton feature='nbCollaborators' />
            </Dropdown.Item>
            <Dropdown.Item style={{ display: 'flex', gap: '10px' }} onClick={(e) => this.changeModalContentType(e, 'RoleList', 'Gestion des rôles', this.props.project, areRightsChangeable)}>
                <FontAwesomeIcon icon={faShieldPlus} style={{ aspectRatio: '1 / 1' }} />{i18n.t("Gérer les rôles")}
                <ProFeaturesButton feature='nbCollaborators' />
            </Dropdown.Item>
            {project.type === 'project' &&
                <>
                    <Dropdown.Item
                        onClick={(e) => this.changeModalContentType(e, 'ImportForm', i18n.t("Import de données"), this.props.project, isImportable)}
                        style={{ display: 'flex', gap: '10px' }}
                    >
                        <FontAwesomeIcon icon={faUpload} style={{ aspectRatio: '1 / 1' }} />
                        {i18n.t("Importer des données")}
                        <ProFeaturesButton feature='import' />
                    </Dropdown.Item>
                    <Dropdown.Item
                        onClick={(e) => this.changeModalContentType(e, 'ExportForm', i18n.t("Export de données"), this.props.project, isExportable)}
                        style={{ display: 'flex', gap: '10px' }}
                    >
                        <FontAwesomeIcon icon={faDownload} style={{ aspectRatio: '1 / 1' }} />
                        {i18n.t("Exporter des données")}
                        <ProFeaturesButton feature='export' />
                    </Dropdown.Item>
                    <Dropdown.Item
                        onClick={(e) => this.changeModalContentType(e, 'ProjectFilesGallery', i18n.t("Fichiers"), this.props.project, isFileGalleryAvailable)}
                        style={{ display: 'flex', gap: '10px' }}
                    >
                        <FontAwesomeIcon icon={faFileAlt} style={{ aspectRatio: '1 / 1' }} />
                        {i18n.t("Fichiers")}
                        <ProFeaturesButton feature='filesSharing' />
                    </Dropdown.Item>
                    <Dropdown.Item icon='setting' text={i18n.t("Paramètres")} disabled={!isEditable} onClick={(e) => this.changeModalContentType(e, 'ProjectModificationForm', 'Paramètres du projet', this.props.project, isEditable)} />
                </>}
        </>);
    }

    changeModalContentType = (event, formType, title, project, canAccess) => {
        if (canAccess) this.props.setProjectShortcut({ formType, title, project });
        else {
            const button = event.currentTarget.querySelector('button');
            if (button) button.click();
        }
    }
}

const mapStateToProps = (state) => {
    return {
        activeOrganization: state.activeOrganization,
        userInfos: state.userInfos,
        project: state.project,
        currentAction: state.currentAction,
        isOnline: state.isOnline,
        sync: state.sync,
        isDarkTheme: state.isDarkTheme,
        projectCollaborators: state.projectCollaborators,
        rights: state.rights,
        loginAsData: state.loginAsData,
        currentFolderState: state.currentFolderState,
        organizations: state.organizations,
        editedProperties: state.editedProperties
    };
};

const mapDispatchToProps = {
    setIsDarkTheme,
    setUserInfos,
    setProjectShortcut,
    setHomeInfos,
    setProjectInvitations,
    setCurrentFolderState
};

export default connect(mapStateToProps, mapDispatchToProps)(BrowserNavbar);